import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  startDiscussion(request: Boundaries["startDiscussion"]["request"]): void;
}

function useStartDiscussion(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isStartDiscussionRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isStartDiscussionRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isStartDiscussionRequestFailure(project),
    ),
    startDiscussion: core.startDiscussion,
  };
}

export { useStartDiscussion };
